import {
  CapitalActionFormState,
  CapitalActionFormValues,
} from '../../hooks/useCapitalActionForm';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { useFormWithStateContext } from 'contexts/FormWithStateContext';
import ShareCapitalCallAllocations from './ShareCapitalCallAllocations';
import React from 'react';
import { sumBy } from 'lodash';

type Props = {
  vehicleId: string;
  index: number;
  baseCurrency: CurrencyCode;
};

const ShareCapitalCallDetails: React.FC<Props> = ({
  index,
  vehicleId,
  baseCurrency,
}) => {
  const {
    formMethods: { watch, setValue },
  } = useFormWithStateContext<
    CapitalActionFormValues,
    CapitalActionFormState
  >();

  const capitalBreakdown = watch(`entries.${index}.capitalBreakdown`);

  const handleAllocationsChange = (
    allocations: Array<{
      commitmentId: string;
      amountLcy: number;
      fundsCalled?: {
        fromCommitmentLcy: number;
        fromRecallableDistributionLcy: number;
      };
    }>,
  ) => {
    const breakdown = allocations.map((allocation) => ({
      commitmentId: allocation.commitmentId,
      amountLcy: allocation.amountLcy,
      fundsCalled: {
        fromCommitmentLcy: allocation.fundsCalled?.fromCommitmentLcy ?? 0,
        fromRecallableDistributionLcy:
          allocation.fundsCalled?.fromRecallableDistributionLcy ?? 0,
      },
    }));

    const total = sumBy(breakdown, 'amountLcy');

    setValue(`entries.${index}.capitalBreakdown`, breakdown);
    setValue(`entries.${index}.totalAmount`, total);
  };

  return (
    <ShareCapitalCallAllocations
      title="Capital contribution"
      calledFundsLabel="Capital contribution called"
      currency={baseCurrency}
      vehicleId={vehicleId}
      onChange={handleAllocationsChange}
      capitalBreakdown={capitalBreakdown ?? []}
    />
  );
};

export default ShareCapitalCallDetails;
